import React from "react";
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Chip,
  Box,
  InputAdornment,
} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ListIcon from '@mui/icons-material/List';

const TenantsMultiSelect = ({
  tenants,
  selectedValues,
  onChange,
  ...props
}) => {
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    onChange(value);
  };
  const handleDelete = (valueToDelete) => () => {
    const newValues = selectedValues.filter((value) => value !== valueToDelete);
    onChange(newValues);
  };
  return (
    <FormControl sx={{ width: "100%" ,mt:2}}>
      <InputLabel sx={{ ml: 3.5, backgroundColor: "white" }}>
        Select Tenants
      </InputLabel>
      <Select
        multiple
        IconComponent={ArrowDropDownIcon}
        // InputProps={{
        //     startAdornment: (
        //       <InputAdornment position="start">
        //        <ListIcon/>
        //       </InputAdornment>
        //     ),
        //   }}
        value={selectedValues}
        onChange={handleChange}
        renderValue={(selected) => (
            <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
              {selected.map((id) => {
                const option = tenants.find((opt) => opt.tenantId === id);
                return option ? (
                  <Chip
                    key={id}
                    label={`${option.tenantId}-${option.tenantName === null ? 'N/A' : option.tenantName}`}
                    onDelete={handleDelete(id)}
                    size="small"
                    color="primary"
                    variant="outlined"
                    sx={{ height: '24px' }}
                    onMouseDown={(e) => e.stopPropagation()} // Prevents select from closing
                  />
                ) : null;
              })}
            </Box>)}
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: "50px", // Adjust this value for more/less rounding
            legend: {
              marginLeft: "30px",
            },
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderRadius: "50px",
            legend: {
              marginLeft: "30px",
            },
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderRadius: "50px",
            legend: {
              marginLeft: "30px",
            },
          },
          '& .MuiSelect-icon': {
            color: 'action.active',
          },
          '& .MuiInputBase-input': {
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '8px', // Add some spacing after the icon
          },
        }}
        {...props}
      >
        {tenants.map((option) => (
          <MenuItem key={option.tenantId} value={option.tenantId} >
            <Checkbox checked={selectedValues.indexOf(option.tenantId) > -1} />
            <ListItemText
              primary={`${option.tenantId}-${
                option.tenantName === null ? "N/A" : option.tenantName
              }`}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TenantsMultiSelect;
